import { render, staticRenderFns } from "./TopUp.vue?vue&type=template&id=36dc3710&scoped=true"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"
import style0 from "./TopUp.vue?vue&type=style&index=0&id=36dc3710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc3710",
  null
  
)

export default component.exports